module.exports = __webpack_public_path__ + "static/assets/790981cea0e9e706d6f3e4cd2e78e8b1.svg";